import React from 'react';
import { useTranslation } from 'react-i18next';
import type { WeatherForecast } from '../../types';

interface WeatherForecastCardProps {
  weather: WeatherForecast;
}

export const WeatherForecastCard: React.FC<WeatherForecastCardProps> = ({ weather }) => {
  const { t } = useTranslation();

  return (
    <div 
      className="border-2 rounded-lg p-4 mb-4 bg-blue-50 border-blue-200 text-blue-900"
      data-testid="weather-forecast"
      role="region"
      aria-label="Weather forecast"
    >
      <h4 className="font-semibold text-lg mb-2" data-testid="weather-title">
        {t('results.weather.title')}
        {weather.details.location_name && (
          <span className="text-sm font-normal text-gray-600 ml-2">
            for {weather.details.location_name}
          </span>
        )}
      </h4>
      
      {weather.details.forecast_date && (
        <p className="text-sm text-gray-500 mb-2" data-testid="forecast-date">
          📅 {weather.details.forecast_date}
        </p>
      )}
      
      <p className="text-sm mb-2" data-testid="weather-summary">
        {weather.summary_text}
      </p>
      
      {weather.details.practical_advice && (
        <p className="text-sm mb-2 font-medium" data-testid="practical-advice">
          💡 {weather.details.practical_advice}
        </p>
      )}
      
      <div className="flex flex-wrap gap-4 text-xs" data-testid="weather-details">
        {weather.details.temperature_range && (
          <span className="flex items-center gap-1" data-testid="temperature-range">
            🌡️ {weather.details.temperature_range}
          </span>
        )}
        {weather.details.conditions && (
          <span className="flex items-center gap-1" data-testid="weather-conditions">
            {weather.details.conditions}
          </span>
        )}
      </div>
    </div>
  );
};
